{
  "alert": "Ειδοποίηση",
  "dismiss": "Απόρριψη"
}